export default {"viewBox":"0 0 20 20","body":"<path d=\"M10 13l5-6H5z\"  fill-rule=\"evenodd\"/>"};